export default __webpack_public_path__ + "static/media/July2019.061d83bb.png";